/**
 * @param {number} value Value
 * @returns {string} Result
 */
export default function getPrice(value) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value)
}
